
class ClientDebug {
    keepFor = 15 * 60 * 1000;
    maxSize = 4000;

    oldBuffer: CaptureItem[] = [];
    buffer: CaptureItem[] = [];

    constructor() {
        setInterval(() => {
            this.checkBuffer();
        }, this.keepFor / 10);
    }

    checkBuffer() {
        const oldest = Date.now() - this.keepFor;

        this.buffer = this.buffer.filter(o => o.dateMs >= oldest);
        this.oldBuffer = this.oldBuffer.filter(o => o.dateMs >= oldest);
    }

    write(name: string, ...args: any[]) {
        this.buffer.push({
            dateMs: Date.now(),
            name: name,
            args: args || [],
        });

        if(this.buffer.length > this.maxSize / 2) {
            this.oldBuffer = this.buffer;
            this.buffer = [];
        }
    }

    makeTrace() {
        const lines = [
            ...this.oldBuffer.map(b => {
                return [b.dateMs.toString(), b.name, ...this.argsToString(b.args)].join("\t") + "\n"
            }),
            ...this.buffer.map(b => {
                return [b.dateMs.toString(), b.name, ...this.argsToString(b.args)].join("\t") + "\n"
            }),
        ];

        const blob = new Blob(lines, { type: "text/plain" });
        return new File([blob], "log.txt", { type: "text/plain" });
    }

    argsToString(input: any[]) {
        return input.map(i => {
            if(typeof i !== "object") {
                return makeString(i);
            }

            // 1-layer deep JSON encoded
            if(i instanceof Array) {
                return JSON.stringify(i.map(v => makeString(v)));
            }

            try {
                const keys = Object.keys(i);
                let obj = {};

                for(let i of keys) {
                    obj[i] = makeString(keys[i]);
                }

                return JSON.stringify(obj);
            } catch (e) {
                return "failed-to-encode:" + i;
            }
        })
    }
}

function makeString(input: any) {
    if(input === null) return "<null>";
    if(input === undefined) return "<undefined>";
    return input.toString();
}

type CaptureItem = {
    dateMs: number;
    name: string;
    args: any[];
}


export const clientDebug = new ClientDebug();

if(window.location.hostname !== "localhost") {

    const originalLog = console.log;
    console.log = (...args) => {
        clientDebug.write("console.log", args);
        originalLog.apply(console, args);
    }

    const originalError = console.error;
    console.error = (...args) => {
        clientDebug.write("console.error", args);
        originalError.apply(console, args);
    }

    const originalWarn = console.warn;
    console.warn = (...args) => {
        clientDebug.write("console.warn", args);
        originalWarn.apply(console, args);
    }

    const originalDebug = console.debug;
    console.debug = (...args) => {
        clientDebug.write("console.debug", args);
        originalDebug.apply(console, args);
    }

    let fetchId = 0;
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {

        let url: string | undefined = undefined;
        let init: RequestInit | Request | undefined = undefined;

        if (args.length > 0) {
            if (typeof args[0] === "string" || args[0] instanceof URL) {
                url = args[0].toString();

                if (args.length >= 2) {
                    init = args[1] as RequestInit;
                }
            } else {
                const request = args[0] as Request;
                url = request.url;
                init = request;
            }
        }

        const method = init?.method || "GET";
        url = url || "<missing-url>"
        fetchId++;
        const id = fetchId;

        clientDebug.write("fetch.start", [
            "id=" + id,
            method,
            url
        ]);

        const tStart = Date.now();
        let ok = false;

        try {
            const rs = await originalFetch.apply(window, args);

            const dur = Date.now() - tStart;
            clientDebug.write("fetch.complete", ["id=" + id, "status=" + rs.status, "duration=" + dur + "ms"]);
            ok = true;

            return rs;
        } finally {
            if (!ok) {
                const dur = Date.now() - tStart;
                clientDebug.write("fetch.fail", ["id=" + id, "duration" + dur + "ms"]);
            }
        }
    }
} else {
    console.log("ClientDebug disabled")
}